import { render, staticRenderFns } from "./month.vue?vue&type=template&id=3fa36df6&scoped=true"
import script from "./month.vue?vue&type=script&lang=js"
export * from "./month.vue?vue&type=script&lang=js"
import style0 from "./month.vue?vue&type=style&index=0&id=3fa36df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa36df6",
  null
  
)

export default component.exports